import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IExpenses } from 'src/app/shared/interfaces/expenses/iexpenses';
import {
  editExpenses,
  saveExpenses,
} from 'src/app/store/expenses/expenses.actions';

@Component({
  selector: 'app-dados-despesas-form',
  templateUrl: './dados-despesas-form.component.html',
  styleUrls: ['./dados-despesas-form.component.scss'],
})
export class DadosDespesasFormComponent {
  form: FormGroup = this.fb.group({
    name: ['', Validators.required],
  });
  id: number = 0;
  unitId = localStorage.getItem('unitId');
  constructor(
    private fb: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private store: Store<IExpenses>
  ) {}

  ngOnInit(): void {
    if (this.config.data && this.config.data.item) {
      this.id = this.config.data.item.id;
      this.popularFormulario(this.config.data.item);
    }
  }
  popularFormulario(item: IExpenses) {
    this.form.controls['name'].setValue(item.name);
  }

  saveForm() {
    const req: IExpenses = {
      unit: `/api/units/${this.unitId}`,
      isGlobal: false,
      name: this.form.value.name,
      expenseType: this.config.data.idTypeExpense,
    };

    if (this.id) {
      this.store.dispatch(editExpenses({ expenses: req, id: this.id }));
    } else {
      this.store.dispatch(saveExpenses({ expenses: req }));
    }
    this.closeForm();
  }
  closeForm() {
    this.ref.close();
  }
}
